export default __webpack_public_path__ + "static/media/html-5.5efd2c77.svg";